import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { ProductRecommendationBasketModel } from "@insite/client-framework/Services/ProductRecommendationsService";
import prepareTrack from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareTrack";
import {
    generateGeneralPrepare,
    mapCartLinesToItems,
} from "@insite/client-framework/Store/Components/ProductRecommendations/ProductRecommendationsSelector";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<{ cart: CartModel }, { recommendation: ProductRecommendationBasketModel }>;

export const PrepareData: HandlerType = props => {
    const {
        getState,
        parameter: { cart },
    } = props;

    const state = getState();
    const session = getSession(state);
    const currency = session?.currency?.currencyCode || "";

    props.recommendation = {
        type: "basket",
        basket: {
            basketId: cart.trackId,
            items: mapCartLinesToItems(state, cart.cartLines),
            currency,
        },
        ...generateGeneralPrepare(state),
    };
};

export const CallPrepareTrack: HandlerType = ({ dispatch, recommendation }) => {
    dispatch(prepareTrack({ prepareTrackData: recommendation }));
};

export const chain = [PrepareData, CallPrepareTrack];

const prepareCart = createHandlerChainRunner(chain, "PrepareCart");
export default prepareCart;
